<template>
  <div
    v-if="pagination?.pageCount > 1"
    :class="$style.root"
  >
    <div
      :class="$style.column"
    >
      <coreButtonsArrowComponent
        @click="$emit('setPage', pagination?.page - 1)"
        :disabled="pagination?.page === 1 ? '' : null"
      />
    </div>
    <div
      :class="$style.column"
    >
      <coreButtonsArrowComponent
        @click="$emit('setPage', pagination?.page + 1)"
        :disabled="pagination?.page === pagination?.pageCount ? '' : null"
        dir="next"
      />
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    pagination: {
      type: Object,
      required: true
    }
  })
</script>

<style module>
  .root {
    composes: container from global;

    display: flex;
    justify-content: center;
    gap: .5ch;

    margin-top: var(--unit--default);
  }

  .column {
    composes: reset-button from global;
  }
</style>
